<template>
<header ref="admin-navigationtop" class="shadow-sm app-header navbar">
  <div id="qsLogo" class="h-100">
    <router-link :to="{ name: 'admin/dashboard' }" class="pl-3 navbar-brand h-100">
      <img height="66" width="200"  :src="require(`../../../assets/clients/${agencyLogo}.svg`)" id="qrp-logo" alt="Rating Platform Logo" v-if="agencyLogo" />
      <img height="66" width="200" src="../../../assets/qrp-abbreviated-color.svg" alt="QuinStreet Rating Platform" v-else />
    </router-link>
  </div>

  <ul class="navbar-nav ml-auto header-nav">
    <li class="nav-item">
      <router-link :to="{ name: 'search' }" class="nav-link">
        <i class="fas fa-search"></i>
        <div class="nav-label">Search Quote</div>
      </router-link>
    </li>
    <li class="nav-item border-left">
       <a href="JavaScript:void(0);" class="nav-link" :class="checkUserEditable()"
         @click.prevent="toUserProfile()" tabindex="0">
         <span class="fas fa-user-circle" title="Dashboard"></span>
            <div class="nav-label">{{ getUserName() }}</div>
        </a>
    </li>
    <li class="nav-item border-left">
      <a href="javascript:void(0)" @click.prevent="logout()" class="nav-link">
        <i class="fas fa-sign-out-alt"></i>
        <div class="nav-label">Logout</div>
      </a>
    </li>
  </ul>

</header>
</template>

<script>
/* global gtag */
import axios from '../../../axios-config';
/* eslint-disable */
// TODO: Use config values
export default {
  data() {
    return {
      agencyLogo: '',
    };
  },
  created() {
    if (this.$store.getters.getAgencyLogo) {
      this.agencyLogo = this.$store.getters.getAgencyLogo;
    }
  },
  methods: {
	/**
    * get User name
    */
    getUserName() {
      return sessionStorage.getItem('userFirstName') + ' ' + sessionStorage.getItem('userLastName');
    },
    /**
    * based on qeury params disabled user profile link
    */
    checkUserEditable() {
      if (this.$route.query && this.$route.query.userID && this.$route.query.userID === sessionStorage.getItem('userId')) {
        return 'disabled';
      }
      return '';
    },
    /**
    * redirect oto user profile page
    */
    toUserProfile() {
      if (this.$route.query.userID !== sessionStorage.getItem('userId')) {
        const userId = sessionStorage.getItem('userId');
        this.$router.push({ path: `/dashboard/your-profile?userID=${userId}` });
      }
    },
    async logout() {
      if (process.env.IS_OKTA_LOGIN_ENABLED) {
        await this.$security.signOut();
      } else {
        axios.post('logout', {
          token: sessionStorage.getItem('refresh_token'),
        }).then().catch((error) => {
          window.console.warn('An error occurred while logging out:', error.message);

          gtag('event', 'exception', {
            description: 'Error logging out',
            fatal: false, // set to true if the error is fatal
          });
        }).then(() => {
          this.$store.commit('clearSessionData');
          this.$store.dispatch('agentLogout', false);
          window.location.href = '/';
        });
      }
    },
  },
};
</script>
<style scoped>
/**Header Container**/
.app-header {
  position: fixed;
  width: 100%;
  height: 3rem;
  border-bottom: none;
  z-index: 1050;
}
  /**logo**/
  .app-header .navbar-brand {
    width: inherit;
    max-width: 100%;
    height: 100%;
  }

  #qsLogo {
    padding: 0.375rem 0;
  }
    #qsLogo a img{
      width: inherit;
      max-width: 200px;
      height: 100%;
    }

  /**Menu Items**/
  .app-header .nav-item {
      margin-top: 1px;
      padding: 0 1.25rem;
  }
    .header-nav .nav-link {
      cursor: pointer;
      color: #003366;
    }
    .header-nav .fas {
      font-size: 17px;
      line-height: 1;
    }
    .header-nav .nav-label {
        margin-top: -3px;
        font-size: 0.75rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/presentational/widgets/Navigationtop.vue?625fd832